import { AlertItem, Severity, FilterType } from './Alerts.types';

export const DEMO_ALERTS: AlertItem[] = [
  {
    id: '1',
    severity: 'crit',
    type: 'POS Delisting',
    when: '6 hours ago',
    title: 'Statholdergaarden delisted all 4 of your references',
    description:
      "All Maison Lefèvre refs (3× Champagne, 1× Burgundy) removed from the wine list in the last quarterly survey. Last sample sent 4 months ago — this POS hasn't been actively engaged since February.",
    context: [
      'Oslo, Norway',
      'Fine dining',
      'Sommelier · Sigrid Bjerke',
      'Owner · Élise'
    ],
    chart: { label: 'Refs · 90 days', value: '4 → 0', direction: 'down' },
    actions: [
      { label: 'Create CRM action', primary: true },
      { label: 'Open POS' },
      { label: 'Resolve' }
    ],
    status: 'unread',
    group: 'Today'
  },
  {
    id: '2',
    severity: 'crit',
    type: 'Market share decline',
    when: '11 hours ago',
    title: 'UK market share dropped 1.2pt in 30 days',
    description:
      'Numeric Distribution fell from 31% to 27% — three competitor brands gained ND in the same window. Largest losses are in the on-trade fine-dining segment.',
    context: ['United Kingdom', 'All SKUs', 'Threshold · −1pt MoM'],
    chart: { label: 'UK ND · 30d', value: '−1.2pt', direction: 'down' },
    actions: [
      { label: 'Open ROI dashboard', primary: true },
      { label: 'Drill by segment' },
      { label: 'Resolve' }
    ],
    status: 'unread',
    group: 'Today'
  },
  {
    id: '3',
    severity: 'warn',
    type: 'Competitive movement',
    when: '14 hours ago',
    title: 'Domaine X gained +12 POS in Norway',
    description:
      'Competitor Domaine X added net 12 new listings in Norwegian fine-dining over 30 days. Their ND jumped from 22% to 26%. 7 of these are POS where you also have refs — direct shelf pressure.',
    context: ['Norway', 'Competitor · Domaine X', '7 overlapping POS'],
    chart: { label: 'Competitor ND', value: '+4pt', direction: 'down' },
    actions: [
      { label: 'View comp. positioning', primary: true },
      { label: 'List 7 overlaps' },
      { label: 'Snooze' }
    ],
    status: 'unread',
    group: 'Today'
  },
  {
    id: '4',
    severity: 'warn',
    type: 'Personnel change',
    when: 'Today, 09:40',
    title: 'Sentralen — sommelier change detected',
    description:
      'Public-facing staff page updated · new head sommelier listed. Wine list shifted by 8 refs in the past 2 weeks — likely curatorial reset. Re-engagement window is opening.',
    context: ['Oslo, Norway', 'Mid-scale dining', 'Status · To Win'],
    chart: {
      label: 'List churn · 30d',
      value: '8 refs swapped',
      direction: 'flat'
    },
    actions: [
      { label: 'Brief commercial team', primary: true },
      { label: 'Open POS' },
      { label: 'Snooze' }
    ],
    status: 'read',
    group: 'Today'
  },
  {
    id: '5',
    severity: 'warn',
    type: 'Pricing anomaly',
    when: 'Yesterday, 18:02',
    title: '2 of your refs priced > 15% below market in Norway',
    description:
      'Vinmonopolet now lists Cuvée Réserve 2021 at NOK 489 (market avg NOK 580) and Brut Tradition NV at NOK 425 (avg NOK 510). May indicate discounting before delisting.',
    context: ['Norway', '2 SKUs affected', '−15% vs market'],
    chart: { label: 'Price gap', value: '−15%', direction: 'down' },
    actions: [
      { label: 'Open price analysis', primary: true },
      { label: 'Flag for review' },
      { label: 'Snooze' }
    ],
    status: 'read',
    group: 'Yesterday'
  },
  {
    id: '6',
    severity: 'good',
    type: 'List expansion',
    when: 'Yesterday, 14:23',
    title: 'Maaemo added 3 Burgundy references',
    description:
      'Including 2 from Domaine Leflaive and 1 from Comte Lafon. Strong signal for cross-selling adjacent terroirs — sommelier Esben Holmboe Bang continues to expand Burgundy section.',
    context: ['Oslo, Norway', '+3 refs', 'Burgundy'],
    chart: { label: 'Total refs', value: '377 → 380', direction: 'up' },
    actions: [
      { label: 'Plan cross-sell', primary: true },
      { label: 'Open POS' },
      { label: 'Resolve' }
    ],
    status: 'read',
    group: 'Yesterday'
  },
  {
    id: '7',
    severity: 'info',
    type: 'New POS surveyed',
    when: 'Yesterday, 11:17',
    title: 'Bjørvika Wine Bar — newly added via Google Maps scrape',
    description:
      'First-time entry from WS-01 pipeline (Norway scraper). 210 references on opening list, including 9 competitor brands. No Maison Lefèvre refs yet — pure prospect.',
    context: [
      'Oslo, Norway',
      'Wine bar',
      'Source · WS-01',
      '9 competitors present'
    ],
    chart: { label: 'Opportunity', value: '210 refs', direction: 'up' },
    actions: [
      { label: 'Add to CRM', primary: true },
      { label: 'Open POS' },
      { label: 'Dismiss' }
    ],
    status: 'read',
    group: 'Yesterday'
  },
  {
    id: '8',
    severity: 'info',
    type: 'Data quality',
    when: 'Yesterday, 08:12',
    title: 'Lofthus Samvirkelag — email-list ingestion needs review',
    description:
      'WS-03 pipeline flagged 6 ambiguous matches in the last wine list received. Likely vintage-year confusion on Loire whites. Manual review recommended before merging.',
    context: ['Lofthus, Norway', 'Source · WS-03', '6 ambiguous matches'],
    chart: { label: 'Match confidence', value: '82%', direction: 'flat' },
    actions: [
      { label: 'Review matches', primary: true },
      { label: 'Open pipeline' },
      { label: 'Dismiss' }
    ],
    status: 'read',
    group: 'Yesterday'
  }
];

export const SEV_COUNTS = { crit: 7, warn: 23, info: 41, good: 18 };
export const SEV_NEW = { crit: 2, warn: 6, info: 12, good: 5 };
export const SEV_LABELS: Record<Severity, string> = {
  crit: 'Critical',
  warn: 'Warning',
  info: 'Info',
  good: 'Positive signals'
};
export const FILTER_TYPES: FilterType[] = [
  'Distribution',
  'Competitive',
  'Pricing',
  'Personnel',
  'Data quality'
];
